(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bracelet"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Metal palettes for the two pavé links in the artwork.
  // light/mid: the link face · u1–u4: left link's shaded underside · r1/r2: right link's darker rim.
  var METALS = {
    silver: { light: 'rgb(182,182,182)', mid: 'rgb(176,176,176)', u1: 'rgb(69,69,69)',   u2: 'rgb(81,81,81)',   u3: 'rgb(106,106,106)', u4: 'rgb(131,131,131)', r1: 'rgb(140,140,140)', r2: 'rgb(118,118,118)' },
    gold:   { light: 'rgb(248,220,138)', mid: 'rgb(214,175,92)',  u1: 'rgb(105,80,28)',  u2: 'rgb(122,94,36)',  u3: 'rgb(150,118,50)',  u4: 'rgb(178,142,66)',  r1: 'rgb(193,148,60)',  r2: 'rgb(170,127,46)' },
    rose:   { light: 'rgb(250,191,157)', mid: 'rgb(213,162,133)', u1: 'rgb(97,60,42)',   u2: 'rgb(115,73,53)',  u3: 'rgb(146,97,72)',   u4: 'rgb(172,120,92)',  r1: 'rgb(194,139,106)', r2: 'rgb(174,121,90)' }
  };
  var CHIP_MID = { silver: '#C7CACE', gold: '#D4AF4F', rose: '#C58974' };

  function chipBackground(a, b) {
    if (a === b) return 'linear-gradient(145deg, #ffffff 0%, ' + CHIP_MID[a] + ' 85%)';
    return 'linear-gradient(135deg, ' + CHIP_MID[a] + ' 0 50%, ' + CHIP_MID[b] + ' 50% 100%)';
  }

  // Whitespace-insensitive so the swatch labels still match the product's
  // option values when they differ only in spacing — "Silver / Gold" in the
  // theme vs "Silver/Gold" in the admin used to silently fail to match.
  function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ''); }

  function initRoot(root) {
    if (root.dataset.brcReady === 'true') return;
    root.dataset.brcReady = 'true';

    var stage      = root.querySelector('.niish-brc__stage');

    // Fetch each bracelet artwork (double + single) and inline it so the page's
    // CSS variables can recolour it. Whichever mode is inactive is just hidden.
    root.querySelectorAll('[data-brc-art]').forEach(function (artHost) {
      if (!artHost.dataset.artUrl || artHost.dataset.loaded === 'true') return;
      fetch(artHost.dataset.artUrl)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (svg) {
          artHost.innerHTML = svg;
          artHost.dataset.loaded = 'true';
        })
        .catch(function (err) {
          if (window.console) console.warn('NIISH bracelet artwork failed to load:', err);
        });
    });

    var cordBtns   = root.querySelectorAll('[data-brc-cord]');
    var linkBtns   = root.querySelectorAll('[data-brc-link]');
    var cordName   = root.querySelector('[data-brc-cord-name]');
    var linkName   = root.querySelector('[data-brc-link-name]');
    var caption    = root.querySelector('[data-brc-caption]');

    // Paint the two-tone chip previews.
    root.querySelectorAll('.niish-brc__chip-dot').forEach(function (dot) {
      dot.style.background = chipBackground(dot.dataset.metalA, dot.dataset.metalB);
    });

    var state = { cordName: '', linkName: '', a: 'silver', b: 'silver', style: 'double' };

    function paintCord(hex, hexDark) {
      if (!stage) return;
      stage.style.setProperty('--brc-cord-l', hex);
      stage.style.setProperty('--brc-cord-d', hexDark || hex);
    }

    // a = left link (stones on top), b = right link (stones below) — two-tone alternates them.
    function paintLinks(a, b) {
      if (!stage) return;
      var A = METALS[a] || METALS.silver;
      var B = METALS[b] || METALS.silver;
      stage.style.setProperty('--brc-a-light', A.light);
      stage.style.setProperty('--brc-a-mid',   A.mid);
      stage.style.setProperty('--brc-a-u1',    A.u1);
      stage.style.setProperty('--brc-a-u2',    A.u2);
      stage.style.setProperty('--brc-a-u3',    A.u3);
      stage.style.setProperty('--brc-a-u4',    A.u4);
      stage.style.setProperty('--brc-b-light', B.light);
      stage.style.setProperty('--brc-b-mid',   B.mid);
      stage.style.setProperty('--brc-b-r1',    B.r1);
      stage.style.setProperty('--brc-b-r2',    B.r2);
    }

    function updateCaption() {
      if (caption) caption.textContent = state.cordName + ' cord · ' + state.linkName + ' links';
    }

    function selectBtn(list, btn) {
      list.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    // ---- Shopify variant wiring (only when a product is connected) ----
    var variantsEl = root.querySelector('[data-brc-variants]');
    var optNamesEl = root.querySelector('[data-brc-optnames]');
    var priceEl    = root.querySelector('[data-brc-price]');
    var idInput    = root.querySelector('[data-brc-variant-id]');
    var addBtn     = root.querySelector('[data-brc-add]');
    var addTxt     = root.querySelector('[data-brc-add-txt]');
    var variants = null, cordOptIdx = -1, linkOptIdx = -1, styleOptIdx = -1;

    if (variantsEl && optNamesEl) {
      try {
        variants = JSON.parse(variantsEl.textContent);
        var names = JSON.parse(optNamesEl.textContent).map(norm);
        cordOptIdx = names.indexOf('cord');
        linkOptIdx = names.indexOf('links');
        if (linkOptIdx === -1) linkOptIdx = names.indexOf('link');
        // The single/double option is whichever 3rd option ISN'T Cord or Links.
        // This works no matter what it's named ("Style", "Ring Type", etc.).
        if (cordOptIdx !== -1 && linkOptIdx !== -1) {
          for (var oi = 0; oi < names.length; oi++) {
            if (oi !== cordOptIdx && oi !== linkOptIdx) { styleOptIdx = oi; break; }
          }
        }
      } catch (e) { variants = null; }
    }

    function findVariant() {
      if (!variants || cordOptIdx === -1 || linkOptIdx === -1) return null;
      var c = norm(state.cordName), l = norm(state.linkName), s = norm(state.style);
      for (var i = 0; i < variants.length; i++) {
        var opts = variants[i].options;
        if (norm(opts[cordOptIdx]) !== c || norm(opts[linkOptIdx]) !== l) continue;
        // If the product has a single/double option, the toggle must match too.
        // Match by "contains" so "Double Pavé Link" counts as double, etc.
        if (styleOptIdx !== -1 && norm(opts[styleOptIdx]).indexOf(s) === -1) continue;
        return variants[i];
      }
      return null;
    }

    // Refuse to sell rather than sell the wrong thing. Whenever the swatches
    // don't resolve to a real variant we blank the price and the variant id, so
    // the form can never post a stale id left over from an earlier selection.
    function setUnsellable(label) {
      if (idInput) idInput.value = '';
      if (priceEl) priceEl.textContent = '—';
      if (addBtn) {
        addBtn.disabled = true;
        if (addTxt) addTxt.textContent = label;
      }
    }

    function syncVariant() {
      if (!variantsEl) return; // editor demo mode — nothing to sync

      // Variant JSON missing/unparseable, or the product isn't built with the
      // Cord + Links options. Previously this returned early and left the
      // first-available variant sitting in the form, so the swatches did
      // nothing and the customer was sold whatever rendered first.
      if (!variants || cordOptIdx === -1 || linkOptIdx === -1) {
        setUnsellable('Unavailable');
        return;
      }

      var v = findVariant();
      if (!v) {
        setUnsellable('Unavailable');
        return;
      }

      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price; // pre-formatted by Liquid
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addTxt) addTxt.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
    }

    // ---- Event handlers ----
    cordBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectBtn(cordBtns, btn);
        state.cordName = btn.dataset.name;
        paintCord(btn.dataset.hex, btn.dataset.hexD);
        if (cordName) cordName.textContent = btn.dataset.name;
        updateCaption();
        syncVariant();
      });
    });

    linkBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectBtn(linkBtns, btn);
        state.linkName = btn.dataset.name;
        state.a = btn.dataset.a;
        state.b = btn.dataset.b;
        paintLinks(state.a, state.b);
        if (linkName) linkName.textContent = btn.dataset.name;
        updateCaption();
        syncVariant();
      });
    });

    // ---- Bracelet style: double vs single link ----
    var modeBtns = root.querySelectorAll('[data-brc-mode]');
    var titleEl = root.querySelector('[data-brc-title]');
    function setMode(mode) {
      root.dataset.mode = mode;
      // Drive the product's single/double option to match the toggle.
      state.style = (mode === 'single') ? 'single' : 'double';
      modeBtns.forEach(function (b) {
        var on = b.dataset.brcMode === mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      // Swap the product title to match the chosen style.
      if (titleEl) {
        titleEl.textContent = (mode === 'single' && titleEl.dataset.headingSingle)
          ? titleEl.dataset.headingSingle
          : titleEl.dataset.headingDouble;
      }
      // A single ring can't be two-toned: if a two-tone finish is currently
      // selected, fall back to the first solid finish (its click re-syncs price).
      if (mode === 'single') {
        var sel = root.querySelector('[data-brc-link].is-selected');
        if (sel && sel.dataset.twotone === 'true') {
          var solid = root.querySelector('[data-brc-link]:not([data-twotone="true"])');
          if (solid) solid.click();
        }
      }
      // Re-match the variant now that Style changed (updates price / add-to-cart).
      syncVariant();
    }
    modeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { setMode(btn.dataset.brcMode); });
    });

    // Last line of defence: never post the form without a resolved variant.
    var form = root.querySelector('.niish-brc__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!idInput || !idInput.value) {
          e.preventDefault();
          setUnsellable('Unavailable');
        }
      });
    }

    // Demo add-to-cart feedback.
    if (addBtn && addBtn.dataset.demo === 'true') {
      addBtn.addEventListener('click', function () {
        var original = addTxt ? addTxt.textContent : '';
        if (addTxt) addTxt.textContent = 'Added ✓';
        setTimeout(function () { if (addTxt) addTxt.textContent = original; }, 1400);
      });
    }

    // Initialise from the pre-selected buttons.
    var firstCord = root.querySelector('[data-brc-cord].is-selected') || cordBtns[0];
    var firstLink = root.querySelector('[data-brc-link].is-selected') || linkBtns[0];
    if (firstCord) { state.cordName = firstCord.dataset.name; paintCord(firstCord.dataset.hex, firstCord.dataset.hexD); }
    if (firstLink) { state.linkName = firstLink.dataset.name; state.a = firstLink.dataset.a; state.b = firstLink.dataset.b; paintLinks(state.a, state.b); }
    updateCaption();
    syncVariant();
  }

  function initAll() { document.querySelectorAll('[data-niish-brc]').forEach(initRoot); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // Re-init inside the theme editor.
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Clear header: flag the section while a search modal, menu drawer or dropdown
  // is open, so the transparent state can step aside for those solid panels.
  // `toggle` doesn't bubble, so listen in the capture phase.
  document.addEventListener(
    'toggle',
    (event) => {
      const sectionHeader = event.target.closest && event.target.closest('.section-header');
      if (!sectionHeader) return;
      sectionHeader.classList.toggle('header-panel-open', sectionHeader.querySelector('details[open]') !== null);
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
